// Utilitários de data do calendário. Tudo em horário LOCAL (sem fuso): o app
// grava datas como "YYYY-MM-DD" e `new Date("YYYY-MM-DD")` é UTC, o que
// deslocaria o dia — por isso o parse é feito à mão.

export const pad = (n) => String(n).padStart(2, "0");

export const toISO = (date) =>
  `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;

export const fromISO = (value) => {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(value || ""));
  if (!m) return null;
  const date = new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
  return Number.isNaN(date.getTime()) ? null : date;
};

export const startOfDay = (date) =>
  new Date(date.getFullYear(), date.getMonth(), date.getDate());

export const sameDay = (a, b) =>
  Boolean(a) &&
  Boolean(b) &&
  a.getFullYear() === b.getFullYear() &&
  a.getMonth() === b.getMonth() &&
  a.getDate() === b.getDate();

export const addMonths = (date, delta) =>
  new Date(date.getFullYear(), date.getMonth() + delta, 1);

export const MONTHS = [
  "janeiro",
  "fevereiro",
  "março",
  "abril",
  "maio",
  "junho",
  "julho",
  "agosto",
  "setembro",
  "outubro",
  "novembro",
  "dezembro",
];

export const WEEKDAY_LETTERS = ["D", "S", "T", "Q", "Q", "S", "S"];
export const WEEKDAY_NAMES = [
  "domingo",
  "segunda-feira",
  "terça-feira",
  "quarta-feira",
  "quinta-feira",
  "sexta-feira",
  "sábado",
];

// "sex., 9 de out."
export const formatHeaderDate = (date) =>
  date
    ? date.toLocaleDateString("pt-BR", {
        weekday: "short",
        day: "numeric",
        month: "short",
      })
    : "";

// "09/10/2026"
export const formatBR = (date) =>
  date ? `${pad(date.getDate())}/${pad(date.getMonth() + 1)}/${date.getFullYear()}` : "";

// Aceita "9/10/2026", "09102026", "09/10/26"; devolve Date ou null.
export const parseBR = (text) => {
  const digits = String(text || "").trim();
  const m =
    /^(\d{1,2})\D+(\d{1,2})\D+(\d{2}|\d{4})$/.exec(digits) ||
    /^(\d{2})(\d{2})(\d{4})$/.exec(digits);
  if (!m) return null;
  const day = Number(m[1]);
  const month = Number(m[2]);
  let year = Number(m[3]);
  if (m[3].length === 2) year += 2000;
  const date = new Date(year, month - 1, day);
  if (
    date.getFullYear() !== year ||
    date.getMonth() !== month - 1 ||
    date.getDate() !== day
  ) {
    return null;
  }
  return date;
};

// Células do mês: [null…null, Date, Date…] (as vazias alinham o 1º dia).
export const buildMonthCells = (monthStart) => {
  const first = new Date(monthStart.getFullYear(), monthStart.getMonth(), 1);
  const days = new Date(first.getFullYear(), first.getMonth() + 1, 0).getDate();
  const cells = Array(first.getDay()).fill(null);
  for (let d = 1; d <= days; d += 1) {
    cells.push(new Date(first.getFullYear(), first.getMonth(), d));
  }
  return cells;
};
